import { render, staticRenderFns } from "./RegistrationSwitch.vue?vue&type=template&id=9a766920&scoped=true&"
import script from "./RegistrationSwitch.vue?vue&type=script&lang=js&"
export * from "./RegistrationSwitch.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSwitch.vue?vue&type=style&index=0&id=9a766920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a766920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
